import AdditionalAreaListItem from './area-list-item-container'

export default AdditionalAreaListItem
